import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-expired-date',
  templateUrl: './expired-date.component.html',
  styleUrls: ['./expired-date.component.scss']
})
export class ModalExpiredDateComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) {  }

  ngOnInit() {
  }
  closeModal() {
      this.activeModal.close(true);
  }
}
